var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "shareModalReport",
        "hide-footer": "",
        centered: "",
        title: "Share on social network",
      },
    },
    [
      _c(
        "div",
        { staticStyle: { "padding-left": "15px", "padding-top": "5px" } },
        [
          _c("h6", [
            _vm._v("\n      Post: "),
            _c(
              "a",
              {
                staticStyle: { "font-size": "15px" },
                attrs: { target: "_blank" },
              },
              [_vm._v(" " + _vm._s(_vm.detailReport.title))]
            ),
          ]),
          _vm._v(" "),
          _c("h6", [_vm._v("Share on:")]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "learning-tool",
          staticStyle: { padding: "15px 0 15px 0" },
        },
        [
          _c("ul", [
            _c("li", [
              _c(
                "a",
                {
                  staticStyle: { "margin-top": "15px" },
                  on: { click: _vm.shareByLink },
                },
                [_c("h3", [_vm._v("Link")])]
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("a", { on: { click: _vm.shareOnFacebook } }, [
                _c("span", { staticClass: "ico" }, [
                  _c("img", {
                    attrs: {
                      src: "content/images/resrouces-social-facebook.png",
                      alt: "",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "name" }, [_vm._v("Facebook")]),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("a", { on: { click: _vm.shareOnTwitter } }, [
                _c("span", { staticClass: "ico" }, [
                  _c("img", {
                    attrs: {
                      src: "content/images/resrouces-social-twitter.png",
                      alt: "",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "name" }, [_vm._v("Twitter")]),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("a", { on: { click: _vm.shareOnLinkedIn } }, [
                _c("span", { staticClass: "ico" }, [
                  _c("img", {
                    attrs: {
                      src: "content/images/resrouces-social-linkedin.png",
                      alt: "",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "name" }, [_vm._v("Linkedin")]),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.isSharingLink
        ? _c(
            "div",
            {
              staticClass: "share-link",
              staticStyle: {
                "margin-top": "10px",
                padding: "0 15px 15px 15px",
              },
            },
            [
              _c("hr", { staticStyle: { "margin-bottom": "10px" } }),
              _vm._v(" "),
              _c(
                "dl",
                { staticClass: "top-title" },
                [
                  _c("h6", [_vm._v("Share with link:")]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { attrs: { label: "Sharing mode" } },
                    [
                      _c("b-form-radio-group", {
                        attrs: {
                          options: [
                            { value: "PUBLIC", text: "Public" },
                            { value: "RESTRICTED", text: "Restricted" },
                          ],
                        },
                        model: {
                          value: _vm.selected,
                          callback: function ($$v) {
                            _vm.selected = $$v
                          },
                          expression: "selected",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.selected === "RESTRICTED"
                    ? _c(
                        "div",
                        [
                          _c("p", [_vm._v("Write something about this post:")]),
                          _vm._v(" "),
                          _c("b-form-textarea", {
                            staticStyle: {
                              "max-height": "100px",
                              "margin-top": "5px",
                              "margin-bottom": "5px",
                            },
                            attrs: {
                              size: "sm",
                              placeholder: "Write something...",
                            },
                            model: {
                              value: _vm.textShare,
                              callback: function ($$v) {
                                _vm.textShare = $$v
                              },
                              expression: "textShare",
                            },
                          }),
                          _vm._v(" "),
                          _vm.checkTextShare
                            ? _c(
                                "div",
                                {
                                  staticClass: "invalid-feedback",
                                  staticStyle: { display: "block" },
                                },
                                [
                                  _vm._v(
                                    "You have to enter at least 10 characters"
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-input-group",
                            {
                              staticClass: "mb-2",
                              attrs: { prepend: "Recipients" },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  "aria-label": "First name",
                                  placeholder: "Search email...",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.searchEmail()
                                  },
                                },
                                model: {
                                  value: _vm.textSearchEmail,
                                  callback: function ($$v) {
                                    _vm.textSearchEmail = $$v
                                  },
                                  expression: "textSearchEmail",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.textSearchEmail
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "max-height": "150px",
                                    "overflow-y": "scroll",
                                  },
                                },
                                [
                                  _vm._l(_vm.resultSearch, function (item) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.email,
                                        staticClass:
                                          "result-search-email d-flex",
                                        staticStyle: {
                                          "text-align": "right",
                                          "margin-right": "5px",
                                          "margin-bottom": "5px",
                                        },
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.emailsSending,
                                              expression: "emailsSending",
                                            },
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            value: item.email,
                                            checked: Array.isArray(
                                              _vm.emailsSending
                                            )
                                              ? _vm._i(
                                                  _vm.emailsSending,
                                                  item.email
                                                ) > -1
                                              : _vm.emailsSending,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = _vm.emailsSending,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = item.email,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.emailsSending =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.emailsSending = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.emailsSending = $$c
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "h6",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "2px",
                                              "margin-left": "10px",
                                            },
                                          },
                                          [_vm._v(_vm._s(item.email))]
                                        ),
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _vm.resultSearch.length === 0
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "text-align": "right",
                                            "margin-right": "5px",
                                            "margin-bottom": "5px",
                                          },
                                        },
                                        [_vm._v("Email not found!")]
                                      )
                                    : !_vm.emailsSending.length
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "invalid-feedback",
                                          staticStyle: { display: "block" },
                                        },
                                        [
                                          _vm._v(
                                            "You have to choose at least 1 email"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "dd",
                            {
                              staticClass: "connected-keyword",
                              staticStyle: { "margin-bottom": "0" },
                              attrs: { id: "hashTag" },
                            },
                            _vm._l(_vm.emailsSending, function (item) {
                              return _c(
                                "a",
                                { key: item, staticClass: "active" },
                                [
                                  _vm._v(_vm._s(item) + "\n            "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "close",
                                      attrs: {
                                        type: "button",
                                        "aria-label": "Close",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeEmail(item)
                                        },
                                      },
                                    },
                                    [_c("i", { staticClass: "bi bi-x" })]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "button-bot" },
                            [
                              _vm.isSendingEmail
                                ? _c(
                                    "b-button",
                                    {
                                      staticClass: "but-share",
                                      staticStyle: {
                                        "margin-top": "10px",
                                        "margin-bottom": "10px",
                                      },
                                      attrs: { size: "sm" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.sendEmail()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            Send Email\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isSendingEmail
                                ? _c(
                                    "b-button",
                                    {
                                      staticClass: "but-share",
                                      staticStyle: {
                                        "margin-top": "10px",
                                        "margin-bottom": "10px",
                                      },
                                      attrs: { disabled: "", size: "sm" },
                                    },
                                    [
                                      _c("b-spinner", {
                                        attrs: { small: "", type: "grow" },
                                      }),
                                      _vm._v(
                                        "\n            Sending...\n          "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c("hr", {
                            staticStyle: { "margin-bottom": "10px" },
                          }),
                          _vm._v(" "),
                          _c("h6", [_vm._v("Link:")]),
                          _vm._v(" "),
                          _c(
                            "b-input-group",
                            { staticClass: "mb-3", attrs: { size: "sm" } },
                            [
                              _c("b-form-input", {
                                model: {
                                  value: _vm.linkPublic,
                                  callback: function ($$v) {
                                    _vm.linkPublic = $$v
                                  },
                                  expression: "linkPublic",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "b-input-group-append",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        text: "Button",
                                        variant: _vm.isCopy
                                          ? ""
                                          : "outline-primary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleCopy()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.isCopy ? "Copied" : "Copy") +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }